module.exports = __webpack_public_path__ + "media/images/emblems/Deitingen-blason-1c4a4205b7fbda463ca817a8e100773f.png";